import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { ProfileService } from "src/app/dashboard/services/profile.service";
import { SubscriptionFormInput } from "src/app/dashboard/model/interface.model";

@Component({
  selector: "app-notification-settings",
  templateUrl: "./notification-settings.component.html",
  styleUrls: ["./notification-settings.component.css"],
})
export class NotificationSettingsComponent implements OnInit {
  subscriptionForm: FormGroup;
  isLoading: boolean = false;

  constructor(private profile: ProfileService) {}

  ngOnInit() {
    this.subscriptionForm = new FormGroup({
      margin_level_alert: new FormControl({ value: true, disabled: true }),
      company_news: new FormControl({ value: true, disabled: true }),
      mt_statement: new FormControl({ value: true, disabled: true }),
      trading_conditions: new FormControl(true),
      analytics: new FormControl(true),
      promo: new FormControl(true),
      blog: new FormControl(true),
      access_notification: new FormControl(false),
      account_setting: new FormControl(false),
    });

    this.getSubscription();
  }

  getSubscription() {
    this.profile.getSubscriptions().subscribe((response) => {
      if (response.data) {
        this.subscriptionForm.patchValue({
          trading_conditions: response.data.trading_conditions,
          analytics: response.data.analytics,
          promo: response.data.promo,
          blog: response.data.blog,
          access_notification: response.data.access_notification,
          account_setting: response.data.account_setting,
        });
      }
    });
  }

  onSubmit() {
    this.isLoading = true;
    let formData: SubscriptionFormInput = {
      trading_conditions: this.subscriptionForm.value.trading_conditions,
      analytics: this.subscriptionForm.value.analytics,
      promo: this.subscriptionForm.value.promo,
      blog: this.subscriptionForm.value.blog,
      access_notification: this.subscriptionForm.value.access_notification,
      account_setting: this.subscriptionForm.value.account_setting,
    };

    this.profile.updateSubscriptions(formData).subscribe(
      (response) => {
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }
}
